import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {DateRenderer} from '../../../components'
import DueDateEditor from "./DueDateEditor";

const Container = styled.div`
  & .property {
    font-weight: bold;
  }
`;

class PeriodInfo extends React.Component {
  saveDate = date => this.props.saveDueDate(date);

  renderDate() {
    const {roles, period: {dueDate}} = this.props;
    return roles.nursingFacility ?
      <DateRenderer value={dueDate}/> :
      <DueDateEditor date={dueDate} onSave={this.saveDate}/>
  }

  renderStatus = () => {
    const {roles, period} = this.props;
    
    return roles.nursingFacility ?
    <div className="row">
          <div className="property col-sm-3">Upload Status:</div>
          <div className="col-sm-9">{period.facilityStatus}</div>
        </div>
    : <div className="row">
    <div className="property col-sm-3">Period Status:</div>
    <div className="col-sm-9">{period.quarterlyStatus}</div>
  </div>
  }

  render() {
    const {period, className} = this.props;
    return (
      <Container className={`${className}`}>
        <div className="row">
          <div className="property col-sm-3">Period:</div>
          <div className="col-sm-9">{period.description}</div>
        </div>

        {this.renderStatus()}

        <div className="row">
          <div className="property col-sm-3">Medical Record Due Date:</div>
          <div className="col-sm-9">{this.renderDate()}</div>
        </div>
      </Container>
    );
  }
}

PeriodInfo.propTypes = {
  period: PropTypes.shape({
    description: PropTypes.string,
    quarterlyStatus: PropTypes.string,
    dueDate: PropTypes.string,
  }).isRequired,
  saveDueDate: PropTypes.func.isRequired,
  roles: PropTypes.shape({
    admin: PropTypes.bool.isRequired,
    nursingFacility: PropTypes.bool.isRequired,
  }).isRequired,
};

export default PeriodInfo;




// WEBPACK FOOTER //
// ./src/modules/sample/components/PeriodInfo.js